import { ApiResponse, Expense, ExpenseMonthSummary } from "../types";
import { apiClient } from "./apiClient";

export interface ExpenseCreatePayload {
  description: string;
  amount: number;
  category?: string | null;
  expenseDate: string;
  isRecurrent?: boolean;
  recurrenceType?: string | null;
  notes?: string | null;
}

export interface ExpenseUpdatePayload extends Partial<ExpenseCreatePayload> {}
export type ExpenseApplyScope = "single" | "future";

const expensesApi = {
  async list(params?: { month?: number; year?: number }): Promise<ApiResponse<Expense[]>> {
    const query = new URLSearchParams();
    if (params?.month) query.set("month", String(params.month));
    if (params?.year) query.set("year", String(params.year));
    const qs = query.toString();
    return apiClient.get<Expense[]>(`/expenses${qs ? `?${qs}` : ""}`);
  },

  async monthSummary(month: number, year: number): Promise<ApiResponse<ExpenseMonthSummary>> {
    return apiClient.get<ExpenseMonthSummary>(
      `/expenses/month-summary?month=${month}&year=${year}`
    );
  },

  async create(payload: ExpenseCreatePayload): Promise<ApiResponse<Expense>> {
    return apiClient.post<Expense>("/expenses", payload);
  },

  async update(
    id: number,
    payload: ExpenseUpdatePayload,
    scope: ExpenseApplyScope = "single"
  ): Promise<ApiResponse<Expense>> {
    return apiClient.put<Expense>(`/expenses/${id}?scope=${scope}`, payload);
  },

  async remove(id: number, scope: ExpenseApplyScope = "single"): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/expenses/${id}?scope=${scope}`);
  },
};

export { expensesApi };
